import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M17.12 11.45A2.24 2.24 0 0014 12s-1.63-1.8-3.13-.55a2.24 2.24 0 00-.22 3.34l.19.18 3 3a.28.28 0 00.4 0l3-3 .18-.18a2.19 2.19 0 00-.3-3.34z"/><path d="M29.71 28.29l-6.55-6.55a12 12 0 10-1.41 1.41l6.55 6.55a1 1 0 001.42 0 1 1 0 00-.01-1.41zM14 24a10 10 0 1110-10 10 10 0 01-10 10z"/>';
export var SavedSearchOutlineSVG = function SavedSearchOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SavedSearchOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SavedSearchOutlineSVG);